@if(!form.showForm()){
<button class="btn btn-standard" (click)="showForm(true)">Add a Note</button>

@for(note of notes(); track note.noteId; let idx = $index) {
<div class="d-flex justify-content-between align-items-baseline gap-4 my-2">
	<div class="d-flex align-items-center">
		<i class='fa-fw fs-5 fa-regular me-2' [ngClass]="note.icon"></i>
		<div class="web-link text-break m-1">
			<p class="fs-6 mb-0">{{note.subject}}</p>
			<p class="fst-italic">{{note.formattedUpdatedDate}}</p>
		</div>
	</div>
	<common-button-row [center]="true">
		<button class="btn btn-standard" (click)="showForm(true, note)">
			<i class="fa-regular fa-pen-to-square"></i>
		</button>
		<button class="btn btn-standard" (click)="confirmNoteDeletion(note.noteId)">
			<i class='fa-regular fa-trash'></i>
		</button>
	</common-button-row>
</div>
}
}

<div class="d-flex flex-column gap-2" [class.d-none]="!form.showForm()">
	<common-select-field [field]="form.category()"></common-select-field>
	<common-text-field [field]="form.subject()"></common-text-field>
	<common-text-field [field]="form.note()"></common-text-field>

	@if(noteToEdit(); as note){
	<div class="d-flex justify-content-evenly mb-3">
		<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
			<tr>
				<td>Created By</td>
				<td>{{note.createdBy}}</td>
			</tr>
			<tr>
				<td>Created On</td>
				<td>{{note.formattedCreatedDate}}</td>
			</tr>
		</table>
		<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
			<tr>
				<td>Updated By</td>
				<td>{{note.updatedBy}}</td>
			</tr>
			<tr>
				<td>Updated On</td>
				<td>{{note.formattedUpdatedDate}}</td>
			</tr>
		</table>
	</div>
	}

	<common-button-row [center]="true">
		<button class="btn btn-standard" (click)="showForm(false)">Cancel</button>
		@if(noteToEdit()){
		<button class="btn btn-standard" (click)="setInitialValuesforEdit()">Revert</button>
		}
		<button #noteFormSaveBtn class="btn btn-primary">{{noteToEdit() ? 'Update' : 'Add'}}</button>
	</common-button-row>
</div>